import type { FC } from 'react';
import React from 'react';

interface IProps {
    className: string;
}

export const CloseIcon: FC<IProps> = ({ className }) => (
    <svg className={className} viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
        <path d="M23.6 1a1 1 0 0 1 1.5 1.4L2.4 25.1A1 1 0 0 1 1 23.6L23.6 1z" />
        <path d="M1 2.4A1 1 0 0 1 2.4 1l22.7 22.6a1 1 0 0 1-1.5 1.5L1 2.4z" />
    </svg>
);
